import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { axiosInstance, isEmptyData } from '../../utils/helper';
import { apiUrlB2B, timeout } from '../../utils/constants';

const initialState = {
	isLoadingLoyalty: false,
	loyalty: null,

	tokenProfile: null,

	tier: null,

	config: null,

	isLoadingVoucher: false,
	vouchers: [],

  hidden: false,
};

export const getVouchersLoyalty = createAsyncThunk('loyality/getVouchersLoyalty', async ({ limit = 10 } = {}, { getState }) => {
	const user = getState().user;
	if (isEmptyData(user?.token)) return;

	const headers = {
		Authorization: `Bearer ${user?.token}`,
	};

	const res = await axiosInstance.get(`loyalty/voucher?limit=${limit}`, { headers, baseURL: apiUrlB2B });
	const data = res?.data?.data;
	return data;
});

export const postLoyaltyProfile = createAsyncThunk('loyalty/profile', async (_, { getState }) => {
	const user = getState().user;
	const headers = {
		Authorization: `Bearer ${user?.token}`,
	};

	const body = {
		countryCode: '62',
		referrerLoyality: '',
	};

	const res = await axiosInstance.post(`/loyalty/profile`, body, { headers, baseURL: apiUrlB2B });
	const data = res?.data?.data;
	return data;
});

const loyalty = createSlice({
	name: 'loyalty',
	initialState,
	reducers: {
		setLoyalty: (state, action) => {
			return { ...state, ...action.payload };
		},
		clearLoyalty: (state) => {
			return {
				...state,
				loyalty: null,
				tokenProfile: null,
				tier: null,
				config: null,
				vouchers: [],
			};
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(postLoyaltyProfile.pending, (state) => {
				state.isLoadingLoyalty = true;
			})
			.addCase(postLoyaltyProfile.fulfilled, (state, action) => {
				state.isLoadingLoyalty = false;

				if (!isEmptyData(action.payload)) {
					state.loyalty = action.payload.profile;
					state.tier = action.payload.tier;
					state.profile = action.payload.profile;
					state.config = action.payload.config;
					state.vouchers = action.payload.vouchers;
					state.tokenProfile = action.payload.tokenProfile;
          state.hidden = action.payload.hidden;
				}
			})
			.addCase(postLoyaltyProfile.rejected, (state) => {
				state.isLoadingLoyalty = false;
			})
			.addCase(getVouchersLoyalty.pending, (state) => {
				state.isLoadingVoucher = true;
			})
			.addCase(getVouchersLoyalty.fulfilled, (state, action) => {
				state.isLoadingVoucher = false;
				state.vouchers = action.payload;
			})
			.addCase(getVouchersLoyalty.rejected, (state) => {
				state.isLoadingVoucher = false;
			});
	},
});

// Export actions and reducer
export const { setLoyalty, clearLoyalty } = loyalty.actions;
export default loyalty.reducer;
